import React from 'react'
import { Accordion } from '@peracto/peracto-blocks'
import AccordionForm from '@peracto/peracto-content/dist/Editor/ContentBlocks/content/Accordion/Form/AccordionForm'

const accordion = {
    ...Accordion,
    FormComponent: props => <AccordionForm {...props} />,
}

export default accordion
